module.exports = __webpack_public_path__ + "static/e27523db.Part03.png";